module.exports = __webpack_public_path__ + "static/media/data_factories.8c551d05.svg";